import RotaryAuthorizedInstaller from './RAI.jsx';

export default RotaryAuthorizedInstaller;
